import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.MatrizTiempos;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

/**
* Componente para editar un Entity
*/
export class MatrizTiemposFormNoRx extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {};
    }

    render() {
        const { value, onGuardar, nuevo } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);
        const Hours = getField(kea.Hours);
        const Sucursal = getField(selectores.Sucursal);

        return (
            <div>
                <kea.Title titulo="MatrizTiempos" onRegresar={() => history.go("../")} />
                {kea.autogrid(6, [
                    <Sucursal field="IdSucursalOrigen" label="Sucursal origen:" />,
                    <Sucursal field="IdSucursalDestino" label="Sucursal destino:" />,
                    <Hours field="Tiempo" label="Tiempo entre sucursales" />
                ])}

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={validation.hasError(this.errors())} />
                    </div>
                </div>
            </div>);
    }
}

export const MatrizTiemposForm = componentToRx(MatrizTiemposFormNoRx);




// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/matricestiempos/edit/form.tsx